import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

const PublicRoute = ({ children, requireAuth = false }) => {
  const { user } = useAuth()

  // ถ้าเป็นหน้าที่ต้องการ login (requireAuth = true) และยังไม่ได้ login
  if (requireAuth && !user) {
    return <Navigate to="/login" replace />
  }

  // ถ้าล็อกอินแล้วและเข้าหน้าแลนดิ้งเพจ ให้ไปหน้าแดชบอร์ด
  if (user && window.location.pathname === '/') {
    return <Navigate to="/dashboard" replace />
  }

  return children
}

export default PublicRoute 